<template lang="pug">
  v-card-text
    validation-provider(
      rules="required"
      vid="task.test1"
      v-slot="{ errors, valid }"
    )
      v-list
        v-list-item-group(
          v-model="answer"
          @change="emitAnswer"
        )
          v-list-item.grey.lighten-4.mb-2.px-2(
            v-for="a in taskUnit.possible_answers" :key="a.id"
            :value="a.id"
          )
            template(#default="{ active }")
              v-list-item-action.mr-3
                v-icon(
                  color="secondary"
                ) {{ !active ? 'mdi-radiobox-blank' : 'mdi-radiobox-marked'}}
              v-list-item-content {{ a.name }}
        //- :error-messages="errors"
</template>

<script>
export default {
  name: 'TypeOneOfMany',
  props: {
    taskUnit: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    answer: null,
  }),
  methods: {
    emitAnswer() {
      this.$emit('answer', {
        fieldName: 'possible_answer_id',
        answer: this.answer,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
